import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import DetailsPanel from 'components/DetailsPanel';
import DefListColumn from 'components/DefListColumn';
import { formatters, TaxWithholdingType } from 'common';
import styles from './styles.css';
import messages from './messages';

const RetirementPanel = ({
  federalTaxWithholdingType,
  federalTaxWithholdingValue,
  stateTaxWithholdingType,
  stateTaxWithholdingValue,
  distributionReason,
  accountRegistration,
  iraReceivingInstitutionName,
  iraContributionDetailsType,
  iraContributionApplyToPriorYear,
  transferDirection,
}) => {
  const isJournal = transferDirection === 'JOURNAL';
  return (
    <DetailsPanel title={<FormattedMessage {...messages.retirement} />}>
      <div className={styles.panel}>
        {distributionReason && (
          <React.Fragment>
            {!iraContributionDetailsType &&
              <DefListColumn
                className={styles.longDataDefList}
                title={<FormattedMessage {...messages.distributionReason} />}
                data={formatters.formatIRADistributionReason(distributionReason)}
                dataTestHandle="retirementPanel__distributionReason"
              />
            }
            {iraContributionDetailsType &&
              <DefListColumn
                className={styles.longDataDefList}
                title={<FormattedMessage {...messages.distributionReason} />}
                data={formatters.formatIRADistributionReason(distributionReason)}
                dataTestHandle="retirementPanel__distributionReasonWithContribution"
              />
            }
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.state} />}
              data={stateTaxWithholdingType === TaxWithholdingType.Fixed
                ? formatters.formatDollars(stateTaxWithholdingValue)
                : `${stateTaxWithholdingValue}%`
              }
              dataTestHandle="retirementPanel__stateTaxWithholding"
            />
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.federal} />}
              data={federalTaxWithholdingType === TaxWithholdingType.Fixed
                ? formatters.formatDollars(federalTaxWithholdingValue)
                : `${federalTaxWithholdingValue}%`
              }
              dataTestHandle="retirementPanel__federalTaxWithholding"
            />
          </React.Fragment>
        )}
        {iraContributionDetailsType && (
          <React.Fragment>
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages[isJournal ? 'journalIraContributionDetailsType' : 'iraContributionDetailsType']} />}
              data={iraContributionDetailsType}
              dataTestHandle="retirementPanel__iraContributionDetailsType"
            />
            <DefListColumn
              className={styles.defList}
              title={<FormattedMessage {...messages.iraContributionApplyToPriorYear} />}
              data={iraContributionApplyToPriorYear ? 'True' : 'False'}
              dataTestHandle="retirementPanel__iraContributionApplyToPriorYear"
            />
          </React.Fragment>
        )}
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.planType} />}
          data={formatters.formatRetirementAccountType(accountRegistration)}
          dataTestHandle="retirementPanel__planType"
        />
        {distributionReason && iraReceivingInstitutionName && !isJournal && (
          <DefListColumn
            className={styles.defList}
            title={<FormattedMessage {...messages.receivingInstitution} />}
            data={formatters.formatRetirementAccountType(iraReceivingInstitutionName)}
            dataTestHandle="retirementPanel__receivingInstitution"
          />
        )}
      </div>
    </DetailsPanel >
  );
};

RetirementPanel.propTypes = {
  federalTaxWithholdingType: PropTypes.oneOf(Object.values(TaxWithholdingType)).isRequired,
  federalTaxWithholdingValue: PropTypes.number.isRequired,
  stateTaxWithholdingType: PropTypes.oneOf(Object.values(TaxWithholdingType)).isRequired,
  stateTaxWithholdingValue: PropTypes.number.isRequired,
  distributionReason: PropTypes.string.isRequired,
  accountRegistration: PropTypes.string.isRequired,
  iraReceivingInstitutionName: PropTypes.string,
  iraContributionDetailsType: PropTypes.string,
  iraContributionApplyToPriorYear: PropTypes.bool,
  transferDirection: PropTypes.oneOf(Object.values(TaxWithholdingType)).isRequired,
};

RetirementPanel.defaultProps = {
  iraReceivingInstitutionName: null,
  iraContributionDetailsType: null,
  iraContributionApplyToPriorYear: null,
};

export default RetirementPanel;



// WEBPACK FOOTER //
// ./src/components/RetirementPanel/index.js